import axios from "axios";
import { useEffect } from "react";
import { API_URL } from "./constants";
import { useSelector } from "react-redux";

function useUTM() {
  const gamePlayerId = useSelector(
    (state) => state.user?.gamePlayerProfile?.gamePlayerId
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    if (
      queryParams.get("utm_campaign") ||
      queryParams.get("utm_source") ||
      queryParams.get("utm_medium") ||
      queryParams.get("utm_id") ||
      queryParams.get("utm_term") ||
      queryParams.get("utm_content")
    ) {
      const payload = {
        utm_campaign: queryParams.get("utm_campaign"),
        utm_medium: queryParams.get("utm_medium"),
        utm_source: queryParams.get("utm_source"),
        utm_term: queryParams.get("utm_term") || "",
        utm_content: queryParams.get("utm_content") || "",
        utm_id: gamePlayerId,
      };
      try {
        window?.mt("send", "pageview", payload);
      } catch (error) {
        console.log("Mautic initialization failed", error);
      }

      axios.post(`${API_URL}/v1/utm`, payload);
    }
  }, [gamePlayerId]);
}

export default useUTM;
